import React, { useEffect, useState } from "react";
import Modal from "../../UIComponents/Modal";
import { ReactComponent as Icon } from "../../../assets/checkbox-tick-icon.svg";
import "./TrialPeriodCompletedModal.scss";
import { Link, useHistory } from "react-router-dom";
import { ReactComponent as Logout } from "../../../assets/svg/trialPeriodEnded/logout.svg";
import { ReactComponent as Email } from "../../../assets/svg/trialPeriodEnded/email.svg";
import { ReactComponent as Chat } from "../../../assets/svg/trialPeriodEnded/chat.svg";

const TrialPeriodCompletedModal = ({ open }) => {
    const history = useHistory();
    // console.log("hiss", history);
    const [openModal, setOpenModal] = useState(false);
    const [searchCompany, setSearchCompany] = useState("");

    useEffect(() => {
        setOpenModal(open);

        return () => {
            zE("webWidget", "close");
            zE("webWidget", "hide");
        };
    }, []);

    useEffect(() => {
        // console.log("aa", history.location.pathname.includes("/subscription"), history.location.pathname);
        if (history.location.pathname.includes("/subscription")) setOpenModal(false);
    }, [history.location]);
    const openHelpChat = () => {
        // webWidget: {
        //     zIndex: 999999
        //   }

        zE("webWidget", "updateSettings", { color: { theme: "#268af6" }, zIndex: 99999999 });
        zE("webWidget", "show");
    };

    const textArr = [
        "Regain all your query, insights, and reports ",
        "You can continue responding to messages you recieved",
        "No worries!  Send your scheduled post you created during trial.",
        "Monitor how your post are performing. ",
        "Get your page insights and competitor insights with us.",
    ];

    return (
        <div className="trial__period__wrapper">
            <Modal show={openModal}>
                <Modal.Content style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <div className="trial__period__container">
                        <div className="top__header">Lets choose a plan!</div>
                        <p className="secondary__text">Looks like, your free trial has ended. Don’t worry your data is safe with us.</p>
                        <div className="arr__wrappper">
                            {textArr.map((text, idx) => (
                                <div key={idx} className="row__text__container">
                                    <Icon />
                                    <p className=" row__text">{text}</p>
                                </div>
                            ))}
                        </div>
                        <div className="button__wrapper">
                            <button
                                className="button"
                                onClick={() => {
                                    history.push("/subscription");
                                }}>
                                <span> Choose Plan</span>
                            </button>

                            <Link to="/profile">Switch Company</Link>
                        </div>
                    </div>
                </Modal.Content>
            </Modal>
            <div className="contact__us__block">
                <div className="logout__div">
                    <Link to="/signout">
                        <Logout />
                        Logout
                    </Link>
                </div>
                <div className="email__us">
                    <a href="mailto: support@radarr.com">
                        <Email />
                        Email us
                    </a>
                </div>
                <div className="chat__with__us" onClick={openHelpChat}>
                    <Chat />
                    Chat with us
                </div>
            </div>
        </div>
    );
};

export default TrialPeriodCompletedModal;
